import { toast } from "react-toastify";
import HttpClient from "./HttpClient";
import useStore from "../Screen/redux/store/useStore";
import { useNavigate } from "react-router-dom";
import { Toast } from "../Component/Toast";



//  POST METHOD
export const post = async (url, data) => {
  try {
    let res = await HttpClient.post(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

//PATCH METHOD
export const patch = async (url, data) => {
  try {
    let res = await HttpClient.patch(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// GET METHOD
export const get = async (url, data) => {
  try {
    let res = await HttpClient.get(url);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

//PUT METHOD
export const put = async (url, data) => {
  try {
    let res = await HttpClient.put(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// DELETE METHOD
export const deletes = async (url, data) => {
  try {
    let res = await HttpClient.delete(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// // FILE IMAGE POST METHOD
// export const file_post = async (url, data) => {
//   try {
//     let res = await httpClientForm.post(url, data);
//     return PrepareResponse(res);
//   } catch (error) {
//     return HandleException(error);
//   }
// };

// FOR RESPONCSE
const PrepareResponse = (res) => {
  if (res?.status) {
    let { status, data } = res;
    if (status >= 200 && status <= 299) {
      if (data.status == "success") {
        return data;
      } else if (data.status == true) {
        return data;
      } else if (data.status == "failure") {
        return data;
      } else if (data.status == "empty") {
        return data;
      } else if (data.status == "error") {
        Toast(data?.message);
        return data;
      } else {
        return data;
      }
    } else {
      Toast(`message: ${data?.message}`);
    }
  } else {
    // Toast("");
  }
  return {};
};

// FOR ERROR HANDLE
const HandleException = (err) => {
  console.log("[ApiHandler] from handleException", err);
  try {
    if (err?.response?.data) {
      let { data, status, statusText, config, headers, request, message } =
        err.response;
      console.warn(`[ApiHandler] API Error Status: ${status} (${statusText})`, { url: config?.url, data });
      if (status == 400) {
        if (data?.errors) {
          // Toast(data?.message + " " + data?.errors);
          Toast(data?.message);
        } else {
          Toast(data?.message || data?.detail);
        }

        return data;
      } else if (status == 401) {
        console.error("[ApiHandler] 🔒 401 Unauthorized detected. Forcing logout.");
        // Toast("You have already logged in another device");
        Toast("Please re-login to access");
        setTimeout(() => {
          console.log("[ApiHandler] Removing token and redirecting...");
          localStorage.removeItem('token');
          sessionStorage.clear();
          window.location.href = "/";
        }, 2000);

      } else if (status == 404) {
        Toast(data?.message ? data?.message : data?.detail ? data?.detail : "Page not found");
      } else {
        Toast(`${data?.message}`);
      }
    } else {
      console.error("[ApiHandler] Network or unexpected error:", err);
      Toast("Something went wrong check or check your internet");
    }
  } catch (error) {
    console.error("[ApiHandler] Exception in HandleException:", error);
    Toast("Someting went wrong or check your internet");
  }
  return {};
};
